import { IKnmReasonChangeType } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonChangeType';

import { IKnmReasonChangeTypeSelectOption } from '../interfaces/IKnmReasonChangeTypeSelectOption';

export function createKnmPlanReasonChangeTypeSelectOption(
  reason: IKnmReasonChangeType,
): IKnmReasonChangeTypeSelectOption {
  return {
    ...reason,
    label: reason.title,
    value: reason.code,
  };
}
